import React from 'react';
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { HomeWithMenu } from '../../components/templates/HomeWithMenu';

export const Route = createFileRoute('/_private/_home')({
  component: HomeShell,
});

function HomeShell() {
  const { apiClient } = Route.useRouteContext();
  return (
    <HomeWithMenu portalApiClient={apiClient}>
      <Outlet />
    </HomeWithMenu>
  );
}
